import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Histroy from "./ArtifactHistory/Histroy";
import Loading from "../../utils/Loader";
import AccordionView from "./AccordionView";
import { CURATOR_PAGE_API_CONSTANT } from "../../constant/constant";

export default function SelectCurrentCurator(props) {
  const [isLookupLoaded, setIsLookupLoaded] = useState(false);
  const currentCurator = useSelector(
    (store) => store?.curatorpage?.selectedCuratorPage
  );

  useEffect(() => {
    setTimeout(() => {
      setIsLookupLoaded(true);
    }, 250);
  }, []);

  const renderPage = () => {
    switch (currentCurator) {
      case "Pending approvals":
        return (
          <AccordionView
            key={CURATOR_PAGE_API_CONSTANT.pending_approval}
            pageName={CURATOR_PAGE_API_CONSTANT.pending_approval}
          />
        );
      case "Yearly review":
        return (
          <AccordionView
            key={CURATOR_PAGE_API_CONSTANT.yearly_review}
            pageName={CURATOR_PAGE_API_CONSTANT.yearly_review}
          />
        );
      case "Artifact history":
        return (
          <Histroy
            key={CURATOR_PAGE_API_CONSTANT.artificat_history}
            pageName={CURATOR_PAGE_API_CONSTANT.artificat_history}
          />
        );
      case "Denied history":
        return (
          <Histroy
            key={CURATOR_PAGE_API_CONSTANT.denied_history}
            pageName={CURATOR_PAGE_API_CONSTANT.denied_history}
          />
        );
      case "Archives":
        return (
          <Histroy
            key={CURATOR_PAGE_API_CONSTANT.archives}
            pageName={CURATOR_PAGE_API_CONSTANT.archives}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full">{isLookupLoaded ? renderPage() : <Loading />}</div>
  );
}
